<template>
  <TimeslotDashboardLayout>
    <template v-slot:mobile-navbar>
      <div
        data-collapse="medium"
        data-animation="over-left"
        data-duration="400"
        data-w-id="df38f32a-3fbb-f2fb-24e9-fdc828eab25c"
        data-easing="ease"
        data-easing2="ease"
        role="banner"
        class="navbar-mobile w-nav"
      >
        <div class="navbar1_container">
          <router-link
            to="/professional-dashboard"
            class="navbar1_logo-link w-nav-brand"
          >
            <img
              src="@/assets/timeslot-images/timeslate-logo.svg"
              loading="lazy"
              alt=""
              class="navbar1_logo"
          /></router-link>

          <div
            @click="showNav"
            class="navbar1_menu-button w-nav-button"
            style="-webkit-user-select: text;"
            aria-label="menu"
            role="button"
            tabindex="0"
            aria-controls="w-nav-overlay-0"
            aria-haspopup="menu"
            aria-expanded="false"
          >
            <div class="menu-icon1">
              <div class="menu-icon1_line-top"></div>
              <div class="menu-icon1_line-middle">
                <div class="menu-icon_line-middle-inner"></div>
              </div>
              <div class="menu-icon1_line-bottom"></div>
            </div>
          </div>
        </div>
        <div
          v-if="cross"
          class="w-nav-overlay"
          data-wf-ignore=""
          id="w-nav-overlay-0"
          style="height: 100vh; display: block; width: 100%;"
        >
          <nav
            role="navigation"
            class="navbar1_menu w-nav-menu"
            style="transform: translateX(0px) translateY(0px);  height: 100vh; transition: transform 400ms ease 0s;"
            data-nav-menu-open=""
          >
            <div class="div-block-4-copy top">
              <div
                data-w-id="df38f32a-3fbb-f2fb-24e9-fdc828eab262"
                class="link-block-3 w-inline-block"
                @click="closeNav"
              >
                <img
                  src="@/assets/timeslot-images/cancel.svg"
                  loading="lazy"
                  alt=""
                />
              </div>
              <div class="div-block-51">
                <div class="div-block-5-copy">
                  <div class="div-block-6-copy">
                    <img
                      v-if="'customerDisplayPicture' in customerInfo"
                      class="image-profile-pic"
                      :src="customerInfo.customerDisplayPicture"
                    />
                    <div class="text-block-8" v-else>
                      {{ userInfo.customerFirstName.charAt(0)
                      }}{{ userInfo.customerLastName.charAt(0) }}
                    </div>
                  </div>
                  <div class="div-block-28">
                    <div class="text-block-6">
                      {{ userInfo.customerFirstName }}
                      {{ userInfo.customerLastName }}
                    </div>
                    <div class="text-block-7">
                      <a @click="goToProfile" class="link-18">View profile</a>
                    </div>
                  </div>
                </div>
                <div class="div-block-29">
                  <router-link
                    to="/professional-dashboard"
                    aria-current="page"
                    class="link-block-4 dashboard w-inline-block w--current"
                  >
                    <div class="text-block-27">Dashboard</div>
                  </router-link>
                  <router-link
                    to="/professional-messages"
                    class="link-block-4 message w-inline-block"
                  >
                    <div class="text-block-27">Messages</div>
                  </router-link>
                  <router-link
                    to="/professional-bookings"
                    class="link-block-4 booking w-inline-block"
                  >
                    <div class="text-block-27">Bookings</div>
                  </router-link>

                  <router-link
                    to="/professional-classes"
                    class="link-block-4 classes w-inline-block"
                  >
                    <div class="text-block-27">Classes</div>
                  </router-link>

                  <router-link
                    to="/professional-subscriptions"
                    class="link-block-4 feeds w-inline-block"
                  >
                    <div class="text-block-27">Subscriptions</div>
                  </router-link>
                  <router-link
                    to="/professional-availability"
                    class="link-block-4 availability w-inline-block"
                  >
                    <div class="text-block-27">Availability</div>
                  </router-link>
                  <router-link
                    to="/professional-wallet"
                    class="link-block-4 wallet w-inline-block"
                  >
                    <div class="text-block-27">Wallet</div>
                  </router-link>
                  <router-link
                    to="/professional-settings"
                    class="link-block-4 settings w-inline-block"
                  >
                    <div class="text-block-27">Settings</div>
                  </router-link>
                  <router-link
                    to="/professional-notifications"
                    class="link-block-4 discover w-inline-block"
                  >
                    <div class="text-block-27">Notifications</div>
                  </router-link>
                </div>
                <div class="div-block-29-copy">
                  <router-link
                    to="/discover-professionals"
                    class="link-block-4 conection w-inline-block"
                  >
                    <div class="text-block-27">Discover</div>
                  </router-link>
                  <router-link
                    to="/professional-support"
                    class="link-block-4 support w-inline-block"
                  >
                    <div class="text-block-27">Support</div>
                  </router-link>
                  <a
                    @click="logout"
                    class="link-block-4 log-out w-inline-block"
                  >
                    <div class="text-block-27">Log out</div>
                  </a>
                </div>
              </div>
            </div>
            <div></div>
          </nav>
        </div>
      </div>
    </template>
    <template v-slot:app-navbar>
      <ProfessionalAppNavBar />
    </template>
    <template v-slot:sidebar>
      <ProfessionalSidebar />
    </template>
    <div class="main-content">
      <div class="welcome-wrappr">
        <div class="text-block-43">Available Slots</div>
      </div>
      <div>
        <p class="intro-avail">
          These are the times that clients would be able to book you for a
          consultation. Each slot lasts for
          <strong>30 minutes</strong> and will be in your
          <strong>local timezone</strong> (Time zone-
          <strong>{{ userInfo.customerTimezone }}</strong
          >).
        </p>
        <p class="intro-avail">
          <strong
            >Note: 20% of your booking fee will be charged by Timeslate per
            consultation</strong
          >
        </p>
      </div>
      <div class="availability-wrapper">
        <div class="days-wrapper" v-for="(day, index) in days" :key="index">
          <div class="day">
            <div class="text-block-102">{{ day }}</div>
          </div>
          <div class="availability-setting-wrapper">
            <div
              class="inactive-wrapper"
              v-if="
                availableGroups.filter(
                  item =>
                    item.availableTimeGroupDayOfWeek.toLowerCase() ===
                    day.toLowerCase()
                ).length === 0 && isSelected !== index
              "
            >
              <div>Unavailable</div>
              <div
                data-w-id="1e3ad98e-f4f0-fe6e-930e-ab41b5a76767"
                class="set-availability"
                @click="openAvailability(index)"
              >
                Set availability
              </div>
            </div>
            <div class="set-date-wrapper" v-if="isSelected === index">
              <div class="time-slot">
                <div class="time-slot-wrapper">
                  <div class="set-timing">
                    <div class="set-timing-1">
                      <FormulateInput
                        type="time"
                        value="00:00"
                        id="available-time"
                        v-model="start"
                      />
                    </div>
                    <div class="set-timing-to">to</div>
                    <div class="set-timing-1">
                      <FormulateInput
                        type="time"
                        value="00:00"
                        id="available-time"
                        v-model="end"
                      />
                    </div>
                  </div>
                </div>
                <div class="div-block-185">
                  <BaseComponentLoader
                    v-if="loader.nonBlockingLoader && !deleting"
                    loaderAlignment="left"
                  />
                  <div
                    v-else
                    data-w-id="ac49ee24-15ce-c157-b62c-2d09e9625ce2"
                    class="button w-button"
                    @click="createGroup(day)"
                  >
                    Save time slot
                  </div>
                  <div
                    data-w-id="5d525943-4f57-bfb4-2650-4822e88c03ad"
                    class="set-availability-copy"
                    @click="closeAvailability(index)"
                  >
                    Cancel
                  </div>
                </div>
              </div>
            </div>
            <div
              class="time-slot-wrapper date-set"
              v-if="
                availableGroups.filter(
                  item =>
                    item.availableTimeGroupDayOfWeek.toLowerCase() ===
                    day.toLowerCase()
                ).length > 0 && isSelected !== index
              "
            >
              <div class="div-block-188">
                <div class="div-block-186-second">
                  <div
                    class="div-block-186-third"
                    v-for="(slot, index) in availableGroups.filter(
                      item =>
                        item.availableTimeGroupDayOfWeek.toLowerCase() ===
                        day.toLowerCase()
                    )"
                    :key="index"
                  >
                    <div class="div-block-186">
                      <div class="timeslot-chosen">
                        {{ slot.availableTimeGroupStartTime.slice(0, 5)
                        }}{{ amPm(slot.availableTimeGroupStartTime) }}
                      </div>
                      <div class="timeslot-chosen-2">to</div>
                      <div class="timeslot-chosen">
                        {{ slot.availableTimeGroupEndTime.slice(0, 5)
                        }}{{ amPm(slot.availableTimeGroupEndTime) }}
                      </div>
                    </div>
                    <div>
                      <a
                        @click="cancelSavedSlot(slot, index)"
                        data-w-id="1446c3bb-238b-0e9a-529c-04aec25a9c44"
                        href="#"
                        class="w-inline-block deleting-state"
                        title="Delete slot"
                      >
                        <p
                          v-if="
                            loader.nonBlockingLoader &&
                              onDelete === slot.availableTimeGroupId
                          "
                        >
                          <strong>Deleting...</strong>
                        </p>
                        <img
                          v-else
                          src="@/assets/timeslot-images/cancelIconNew.svg"
                          loading="lazy"
                          alt=""
                      /></a>
                    </div>
                  </div>
                  <div class="new-slot-margin" @click="openAvailability(index)">
                    <a href="#" class="link-22">Add new slot</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--      <Calendar />-->
    </div>
    <template v-slot:right-side-nav>
      <ProfRightSideMenu />
    </template>
  </TimeslotDashboardLayout>
</template>

<script>
import TimeslotDashboardLayout from "@/views/timeslot/TimeslotDashboardLayout";
import ProfRightSideMenu from "@/views/timeslot/ProfRightSideMenu";
import ProfessionalAppNavBar from "@/components/navbar/ProfessionalAppNavBar";
import ProfessionalSidebar from "@/views/timeslot/ProfessionalSidebar";
// import Calendar from "@/components/BaseComponents/Calendar";
import { mapState } from "vuex";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import AvailableTimeRequest from "@/model/requests/AvailableTimeRequest";
import BaseComponentLoader from "@/components/BaseComponents/BaseComponentLoader";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import ReviewRequest from "@/model/requests/ReviewRequest";
import BookingRequest from "@/model/requests/BookingRequest";
export default {
  name: "ProfessionalAvailability",
  components: {
    BaseComponentLoader,
    ProfRightSideMenu,
    TimeslotDashboardLayout,
    ProfessionalAppNavBar,
    ProfessionalSidebar
  },
  data() {
    return {
      setAvailability: false,
      bar: true,
      cross: false,
      savedSlot: false,
      readModel: AvailableTimeRequest.readByProfessionalId,
      days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      isSelected: null,
      unavailable: true,
      createModel: AvailableTimeRequest.createAvailableTimeGroup,
      start: "00:00",
      end: "00:00",
      deleteModel: AvailableTimeRequest.delete,
      deleting: null,
      onDelete: null,
      reviewListModel: ReviewRequest.readByProfessionalId,
      readBookingModel: BookingRequest.readByProfessionalId
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      availableGroups: state => state.availability.availableGroups,
      customerInfo: state => state.customer.customerInfo,
      customerToProfessionalId: state =>
        state.professional.customerToProfessionalId
    }),
    professionalInfo: state => state.professional.professionalInfo,
    ...mapState(["loader"])
  },
  methods: {
    createGroup(day) {
      if ("professional" in this.userInfo) {
        this.createModel.availableTimeGroupProfessionalId = this.userInfo.professional.professionalId;
      } else {
        this.createModel.availableTimeGroupProfessionalId = this.customerToProfessionalId;
      }
      this.createModel.availableTimeGroupDayOfWeek = day;
      this.createModel.availableTimeGroupStartTime = `${this.start}:00`;
      this.createModel.availableTimeGroupEndTime = `${this.end}:00`;
      this.deleting = false;
      StoreUtils.dispatch(
        "availability/createAvailableTimeGroup",
        this.createModel
      ).then(() => {
        this.isSelected = null;
        if ("professional" in this.userInfo) {
          this.readModel.professionalId = this.userInfo.professional.professionalId;
        } else {
          this.readModel.professionalId = this.customerToProfessionalId;
        }
        StoreUtils.dispatch(
          "availability/readByProfessionalId",
          this.readModel
        );
      });
    },
    amPm(value) {
      let timeValue = parseInt(value.slice(0, 2));
      if (timeValue >= 12) {
        return "pm";
      } else {
        return "am";
      }
    },
    openAvailability(index) {
      this.isSelected = index;
      this.setAvailability = true;
    },
    closeAvailability(index) {
      this.isSelected = null;
      this.setAvailability = false;
    },
    showSavedSlot(index) {
      this.isSelected = index;
      this.savedSlot = true;
      this.setAvailability = false;
    },
    cancelSavedSlot(slot) {
      // this.isSelected = !index;
      // this.isSelected = index;
      this.onDelete = slot.availableTimeGroupId;
      this.savedSlot = false;
      this.setAvailability = false;
      this.deleting = true;
      this.deleteModel.availableTimeGroupId = slot.availableTimeGroupId;
      if ("professional" in this.userInfo) {
        this.deleteModel.availableTimeGroupProfessionalId = this.userInfo.professional.professionalId;
      } else {
        this.deleteModel.availableTimeGroupProfessionalId = this.customerToProfessionalId;
      }
      this.deleteModel.availableTimeGroupStartTime =
        slot.availableTimeGroupStartTime;
      this.deleteModel.availableTimeGroupEndTime =
        slot.availableTimeGroupEndTime;
      StoreUtils.dispatch(
        "availability/deleteAvailableTimeGroup",
        this.deleteModel
      ).then(() => {
        if ("professional" in this.userInfo) {
          this.readModel.professionalId = this.userInfo.professional.professionalId;
        } else {
          this.readModel.professionalId = this.customerToProfessionalId;
        }
        StoreUtils.dispatch(
          "availability/readByProfessionalId",
          this.readModel
        );
      });
    },
    goToProfile() {
      let professionalId;
      if ("professional" in this.userInfo) {
        professionalId = this.userInfo.professional.professionalId;
      } else {
        professionalId = this.customerToProfessionalId;
      }
      RouterUtils.changeRouteUrlTo(`/professionals/${professionalId}`);
    },
    logout() {
      StoreUtils.dispatch(StoreUtils.actions.auth.LOGOUT);
    },
    showNav() {
      this.cross = true;
      this.bar = false;
    },
    closeNav() {
      this.bar = true;
      this.cross = false;
    }
  },
  beforeMount() {
    if ("professional" in this.userInfo) {
      this.readModel.professionalId = this.userInfo.professional.professionalId;
      this.reviewListModel.professionalId = this.userInfo.professional.professionalId;
      this.readBookingModel.bookingProfessionalId = this.userInfo.professional.professionalId;
    } else {
      this.readModel.professionalId = this.customerToProfessionalId;
      this.reviewListModel.professionalId = this.customerToProfessionalId;
      this.readBookingModel.bookingProfessionalId = this.customerToProfessionalId;
    }
    StoreUtils.dispatch("availability/readByProfessionalId", this.readModel);
    StoreUtils.dispatch("professional/readReviews"), this.reviewListModel;
    StoreUtils.dispatch(
      StoreUtils.actions.booking.READ_BY_BOOKING_PROFESSIONAL_ID,
      this.readBookingModel
    );
  }
};
</script>

<style scoped>
.div-block-186-third {
  display: flex;
  justify-content: space-between;
  width: 100%;
  /*margin-top: 7px;*/
  /*background-color: #0098da;*/
}
.new-slot-margin {
  margin-top: 15px;
}

.div-block-188 {
  /*display: flex;*/
  /*justify-content: space-between;*/
  width: 100%;
}
.intro-avail {
  font-size: 14px;
}
.set-timing {
  display: flex;

  align-items: center;
  gap: 15px;
  margin-bottom: 0;
}
.set-timing-to {
  align-self: center;
  position: relative;
  top: 0px;
}
.set-timing-1 {
  margin-bottom: 0;
  padding-bottom: 0;
  height: 50px;
}
.timeslot-chosen {
  margin-right: 0px;
  margin-left: 0px;
  border-style: solid;
  border-width: 1px;
  border-color: rgba(3, 28, 67, 0.1);
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 10px;
}
.timeslot-chosen-2 {
  margin-bottom: 10px;
}
.link-22 {
  font-size: 14px;
  text-decoration: none;
  font-family: "Galano grotesque-Medium", sans-serif;
}
@media only screen and (max-width: 600px) {
  .deleting-state {
    margin-left: 20px;
  }
}
</style>
